var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-button',_vm._g(_vm._b({class:{ 'button': true, [_vm.size]: true },style:(_vm.bgColor ? { backgroundColor: `${_vm.bgColor} !important` } : null),attrs:{"icon-pack":"feather","icon":_vm.$attrs.icon ? `icon-${_vm.$attrs.icon}` : ''}},'vs-button',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }